import { ENTITY_TYPES } from '@shared/enums/entityTypes.enum';

export interface IEntityI18nFieldConfig {
    field: string;
    originField?: string;
}

export const ENTITY_I18N_FIELD_MAP: Record<ENTITY_TYPES, IEntityI18nFieldConfig[]> = {
    [ENTITY_TYPES.SITE]: [{ field: 'name', originField: 'originName' }],
    [ENTITY_TYPES.EVENTS]: [{ field: 'name', originField: 'originName' }]
};
